var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666564",
    fillRule: "evenodd",
    d: "M8.333 13.333c0 .459-.375.834-.834.834-.458 0-.833-.375-.833-.834V10c0-.458.375-.833.833-.833.459 0 .834.375.834.833v3.333zm5 0c0 .459-.375.834-.834.834-.458 0-.833-.375-.833-.834V10c0-.458.375-.833.833-.833.459 0 .834.375.834.833v3.333zm1.666 2.5c0 .46-.373.834-.833.834H5.833c-.46 0-.834-.375-.834-.834V6.667h10v9.166zM8.333 3.607c0-.13.178-.274.416-.274h2.5c.239 0 .417.145.417.274V5H8.333V3.607zM17.499 5h-4.166V3.607c0-1.07-.934-1.94-2.084-1.94h-2.5c-1.149 0-2.083.87-2.083 1.94V5H2.499c-.458 0-.833.375-.833.833 0 .459.375.834.833.834h.834v9.166c0 1.379 1.121 2.5 2.5 2.5h8.333c1.378 0 2.5-1.121 2.5-2.5V6.667h.833c.459 0 .834-.375.834-.834 0-.458-.375-.833-.834-.833z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_trash.f23bc4a9.svg";
export { ForwardRef as ReactComponent };